import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getGoogleCalendars(params = {}) {
  return axios.get('/ajax/google_calendars', { params })
}

export function getGoogleCalendar(id) {
  return axios.get(`/ajax/google_calendars/${id}`)
}

export function syncGoogleCalendars() {
  return axios.post('/ajax/google_calendars/sync')
}
